/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import {
    EWidgetSubscriberMobile,
} from '../../../../pages/PageDashboard/components/Widgets/WidgetSubscriberMobile/widgetSubscriberMobileTypes';
import { mapWidgetSubscriberTabTypeToGTMTabType } from '../types/GTMMapTypes';
import { IGTMOperation } from './index';

export enum EGTMWidgetSubscriberMobileLabel {
    activeSubs = 'Активен',
    blockedSubs = 'Заблокирован',
    noSimCardSubs = 'Без сим-карты',
}

export const clickLinkLabelWidgetSubscriberMobile = (label: EGTMWidgetSubscriberMobileLabel): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e14',
    'event_cat': 'Абоненты по меткам и тарифам',
    'event_name': 'clickElement',
    'event_param': label,
});

export const clickTabWidgetSubscriberMobile = (tab: EWidgetSubscriberMobile): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v217-e15',
    'event_cat': 'Абоненты по меткам и тарифам / Tabs',
    'event_name': 'clickLinks',
    'event_param': mapWidgetSubscriberTabTypeToGTMTabType[tab],
});

export const onClickTabGroupWidgetSubscriberMobile =
    (group: string, tab: EWidgetSubscriberMobile): IGTMOperation => ({
        'event': 'addEvents_makeActions',
        'event_id': 'd-v217-e16',
        'event_cat': 'Абоненты по меткам и тарифам',
        'event_name': 'clickElement',
        'event_param': `${mapWidgetSubscriberTabTypeToGTMTabType[tab]} / ${group}`,
    });

export const clickSetupLabelsLinkWidgetSubscriberMobile: IGTMOperation = ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e17',
    'event_cat': 'Абоненты по меткам и тарифам',
    'event_name': 'clickElement',
    'event_param': 'Настроить метки',
});
